import { Injectable } from "@angular/core";

declare var dataLayer:any;
@Injectable()
export class AnalyticsUtilsService{ 
    public click_on_option_property(category){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Click on Option Property`,
            'eventLabel': `${category}`
        });
    }
    public click_on_continue(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Click on continue`,
        })
    }
    public click_on_cookies(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Cookies accepted`,
        })
    }
    public click_on_download(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Click on download`,
        })
    }

    public click_on_pay(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Click on pay`
        })
    }

    public go_step(page:number){
        return dataLayer.push({
            'event':'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': 'Next step',
            'eventLabel': `${page}`
        });
    }
    
    public apply_coupon(coupon:string){
        return dataLayer.push({
            'event':'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': 'Apply Coupon',
            'eventLabel': `${coupon}`
        });
    }

    public click_on_routes(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Click on Routes`
        })
    }

    public click_on_cruise(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Click on Cruise`
        })
    }

    public change_date(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Change Date`
        })
    }

    public change_pax(){
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': `Change Pax`
        })
    }

    public open_gallery(){
        return dataLayer.push({
            'event':'behaviour',
            'eventCategory':'Behaviour',            
            'eventAction': 'Open Gallery'
        })
    }

    public click_on_cross_sell(){
        return dataLayer.push({
            'event':'behaviour',
            'eventCategory':'Behaviour',            
            'eventAction': 'Click on cross selling'
        })
    }

    public click_on_price(){
        return dataLayer.push({
            'event':'behaviour',
            'eventCategory':'Behaviour',            
            'eventAction': 'Click on price'
        })
    }

    public click_on_newsletter(){
        return dataLayer.push({
            'event':'behaviour',
            'eventCategory':'Behaviour',            
            'eventAction': 'Click on newsletter'
        })
    }

    /** User search and get results */
    public user_search_with_result(searchDone: string) {
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': 'Result',
            'eventLabel': `${searchDone}`
        });
    }

    /** User search and get NO results */
    public user_search_with_no_result(searchDone: string) {
        return dataLayer.push({
            'event': 'behaviour',
            'eventCategory': 'Behaviour',
            'eventAction': 'No_result',
            'eventLabel': `${searchDone}`
        });
    }

    /**
     * Sends a virtual page view to analyticis. 
     * @param url fake url of the virtual page that will be pushed to analytics
     * @param pageTitle title of the virtual page
     */
    public send_virtual_page(url:string, pageTitle:string){
        return dataLayer.push({
            'event':'VirtualPageview',
            'virtualPageURL':url,
            'virtualPageTitle' : pageTitle
        });
    }

    public eCommerce_productViews(products:any[]){
        products = products.map(p => {
            return {id:p.id, name:p.name};
        });
        return dataLayer.push({
            'event': 'Product Impression',
            'ecommerce': {
                'impressions': products
            }
        });
    }

    public eCommerce_productClick(product:any){
        return dataLayer.push({
            'event': 'Product Click',
            'ecommerce': {
                'click': {
                    'products':[{
                        'id': product.id,
                        'name': product.name
                    }]
                }
            }
        });
    }

    public eCommerce_productDetails(product:any,options:any){     
        return dataLayer.push({
            'event': 'Product Detail Impression',
            'ecommerce': {
                'detail': {
                    'products':[{
                        'id': product.id,
                        'name': product.name
                    }]
                }
            }
        });
    }

    public eCommerce_addToCart(product:any, option:any, currencyStr:string):boolean{
        return dataLayer.push({
            'event': 'Add to Cart',
            'ecommerce': {
                'add':{
                    'currencyCode': currencyStr,
                    'products':[{
                        'id': product.id,
                        'name': product.name,
                        'price': option.total,
                        'quantity': 1,
                        'variant': option.id
                    }]
                }
            }
        });
    } 

    public eCommerce_removeFromCart(option:any, currencyStr:string):boolean{
       return dataLayer.push({
            'event': 'Remove from Cart',
            'ecommerce': {
                'remove':{
                    'currencyCode': currencyStr,
                    'products':[{
                        'id': option.productId,
                        'name': option.product,
                        'price': option.amount,
                        'quantity': 1,
                        'variant': option.optionId
                    }]
                }
            }
        });
    }

    public eCommerce_checkout(options:any[], currencyStr:string){
        let products = options.map(o => {
            return {
                'id': o.productId,
                'name': o.product,
                'price': o.amount,
                'quantity': 1,
                'variant': o.optionId
            }
        });
        return dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout':{
                    'currencyCode': currencyStr,
                    'products': products
                }
            }
        });
    }

    public eCommerce_purchase(transaction:any, currencyStr:string){
        let products = transaction.sales.map(sale => {
            let product = {
                'id': sale.productId,
                'name': sale.product,
                'price': sale.amount,
                'quantity': 1,
                'variant': sale.optionId
            };
            return product;
        });

        dataLayer.push({
            'event': 'gtm.purchase',
            'ecommerce': {
                'currencyCode': currencyStr,
                'purchase': {
                    'actionField': {
                        'id': transaction.payment.reference,
                        'revenue': transaction.payment.amount,
                        'quantity': 1
                    },
                    'products': products
                }
            }
        });
    }
}